import { FunctionComponent } from 'react';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import SelectInput from '../SelectInput';
import { SelectOption } from '../../hooks/useMapRegionComuna';

type Props = {
  regiones: SelectOption[];
  comunas: SelectOption[];
  selectedRegion: string;
  selectedComuna: string;
  loading: boolean;
  onRegionChange: (id: string) => void;
  onComunaChange: (id: string) => void;
};

/**
 * Selector de región/comuna idéntico al de PublicMapPage y PrivateMapPage.
 * Reutilizable por HeatMapPage (público) y PrivateNodalHeatMapPage (privado).
 */
const MapLocationSelector: FunctionComponent<Props> = ({
  regiones,
  comunas,
  selectedRegion,
  selectedComuna,
  loading,
  onRegionChange,
  onComunaChange
}) => (
  <div className='public-map-location-container'>
    <span className='vdr-icon-tile vdr-map-location-tile' aria-hidden='true'>
      <PlaceOutlinedIcon />
    </span>
    <div className='public-map-location-selector-section-container'>
      <div className='public-map-location-input-container'>
        <label className='primary-label-style'>Región</label>
        <SelectInput
          label='Selecciona Región'
          name='region'
          id='region'
          value={selectedRegion}
          onChange={(e) => onRegionChange(e.target.value)}
          options={regiones}
          disabled={loading}
        />
      </div>
      <div className='public-map-location-input-container'>
        <label className='primary-label-style'>Comuna</label>
        <SelectInput
          label='Selecciona Comuna'
          name='commune'
          id='commune'
          value={selectedComuna}
          onChange={(e) => onComunaChange(e.target.value)}
          options={comunas}
          disabled={loading}
        />
      </div>
    </div>
  </div>
);

export default MapLocationSelector;
